import React, { useState, useEffect } from 'react';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { useGoogleLogin, googleLogout } from '@react-oauth/google';
import translations from '../constants/translations.json';
import axios from 'axios';
import { isEmpty } from 'lodash';
import configData from '../config.json';
import { ToastContainer, toast } from 'react-toastify';
import { deleteUserToken } from '../utils/firebase';
import { useNotificationContext } from '../context/notification';
import { useOrderContext } from '../context/order';
import { useRestaurantContext } from '../context/restaurants';
import { useDataContext } from '../context/data';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Modal } from '../components/ui/Modal';
import MobileNavbar from './MobileNavbar';
import LanguageSelectorDropdown from './LanguageSelectorDropdown';
import QrScanView from './QrScanView';
import { fetchSubscription } from '../utils/heywaitrPlusApi';
import { isSubscriptionActive, syncCachedSubscribed } from '../utils/heywaitrPlus';
import { signOutSession } from '../utils/authSession';
import { mergeGuestWallet } from '../utils/stampWalletMerge';

// Reusable class strings
const inputCls =
  'w-full py-3 px-4 text-sm bg-[#f5f5f5] border border-transparent rounded-[10px] outline-none text-[#333] transition-[border-color] duration-200 focus:border-[#96c11f]';

const inputErrorCls =
  'w-full py-3 px-4 text-sm bg-[#f5f5f5] border border-red-400 rounded-[10px] outline-none text-[#333] transition-[border-color] duration-200 focus:border-[#96c11f]';

const labelCls = 'text-[11px] font-semibold text-[#555] uppercase tracking-[0.5px] mb-1 block';

export default function Navbar(props) {
  let pathname = window.location.pathname;
  const restaurantId = pathname.split('/')?.[2];
  const navigate = useNavigate();

  const notificationContext = useNotificationContext();
  const orderContext = useOrderContext();
  const restaurantContext = useRestaurantContext();
  const { setMyCards, setCheckOutItems, userProfile, setUserProfile, language } = useDataContext();

  const restaurant = restaurantContext?.restaurant;

  const [toggleCreateAccountModal, setToggleCreateAccountModal] = useState(false);
  const [basicModal2, setBasicModal2] = useState(false);
  const [basicModal3, setBasicModal3] = useState(false);
  const [loginLoading, setLoginLoading] = useState(false);
  const [loginError, setLoginError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const loginEmailRef = React.useRef(null);
  const [signupLoading, setSignupLoading] = useState(false);
  const [signupError, setSignupError] = useState('');
  const [showSignupPassword, setShowSignupPassword] = useState(false);
  const signupFirstNameRef = React.useRef(null);
  const [signupSuccess, setSignupSuccess] = useState(false);

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [contact, setContactSignUp] = useState('');
  const [agree_to_terms, setAgreeTerms] = useState('');

  const [signupData, setSignupData] = useState({});

  const [forgotPassword, setForgotPassword] = useState(false);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');

  const [shareLinkCopied, setShareLinkCopied] = useState(false);

  useEffect(() => {
    if (!restaurantId) {
      restaurantContext.setRestaurant(null);
    }
  }, [restaurantId]);

  useEffect(() => {
    if (
      typeof localStorage.getItem('user_profile') !== 'undefined' &&
      localStorage.getItem('user_profile') !== null
    ) {
      checkreepayregistration();
      setUserProfile(JSON.parse(localStorage.getItem('user_profile') || null));
    }

    const guestId = localStorage.getItem('guest-uui');
    if (guestId) {
      orderContext.setIsGuest(true);
      orderContext.setGuestId(guestId);
    }
  }, []);

  // Reconcile the HeyWaitr+ badge/dropdown with the live subscription, since the
  // cached `isSubscribed` login flag can be stale across devices — e.g. a
  // cancelled-but-not-yet-expired membership still grants access here but reads as
  // not subscribed on a fresh login elsewhere.
  useEffect(() => {
    const token = JSON.parse(localStorage.getItem('user_profile') || 'null')?.token;
    if (!token) return undefined;
    let aborted = false;
    (async () => {
      try {
        const sub = await fetchSubscription(token);
        if (aborted) return;
        const merged = syncCachedSubscribed(isSubscriptionActive(sub));
        if (merged) setUserProfile(merged);
      } catch (e) {
        // Leave the cached flag untouched on transient errors.
      }
    })();
    return () => {
      aborted = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (orderContext?.loginModal) {
      setBasicModal3(true);
    } else {
      setBasicModal3(false);
    }
  }, [orderContext?.loginModal]);

  useEffect(() => {
    if (!basicModal3) {
      orderContext?.setLoginModal(false);
      setLoginError('');
      setShowPassword(false);
    } else {
      setTimeout(() => loginEmailRef.current?.focus(), 300);
    }
  }, [basicModal3]);

  useEffect(() => {
    if (orderContext?.registerModal) {
      setToggleCreateAccountModal(true);
    }
  }, [orderContext?.registerModal]);

  useEffect(() => {
    if (toggleCreateAccountModal) {
      setTimeout(() => signupFirstNameRef.current?.focus(), 300);
    } else {
      setSignupError('');
      setShowSignupPassword(false);
      orderContext?.setRegisterModal?.(false);
    }
  }, [toggleCreateAccountModal]);

  const checkreepayregistration = async () => {
    try {
      let userProfile = JSON.parse(localStorage.getItem('user_profile'));

      const request = await axios({
        method: 'GET',
        url: `${configData.SERVER_URL}/user/checkreepayregistration`,
        headers: {
          Authorization: `Bearer ${userProfile?.token || ''}`,
        },
      });
    } catch (ex) {
      console.log('checkreepayregistration() => ', ex.message);
    }
  };

  const logOut = async (response) => {
    signOutSession();
    localStorage.removeItem('user_profile');
    localStorage.removeItem('orders');
    localStorage.removeItem('hw_pending_orderv2');
    localStorage.removeItem('guest-uui');

    orderContext.setIsGuest(false);
    orderContext.setGuestId('');

    setUserProfile([]);
    googleLogout();
    deleteUserToken();
    navigate('/');
  };

  const toggleShow2 = () => {
    if (userProfile !== undefined && userProfile !== null && userProfile.profile) {
      const my_orders = JSON.parse(localStorage.getItem('orders'));
      const orderInfo = JSON.parse(localStorage.getItem('hw_preorder_info'));

      axios({
        method: 'GET',
        url: `${configData.SERVER_URL}/orders/v2/pmlists?restaurant=${orderInfo?.restaurant_id}`,
        data: null,
        headers: {
          Authorization: `Bearer ${userProfile.token}`,
        },
      }).then((response) => {
        setMyCards?.(response.data);
      });
      setCheckOutItems?.(my_orders);
      setBasicModal2(!basicModal2);
    } else {
      setBasicModal3(!basicModal3);
    }
  };

  const usernameChange = (value) => setUsername(value);
  const passwordChange = (value) => setPassword(value);
  const emailChange = (value) => setEmail(value);
  const contactChangeSignUp = (value) => setContactSignUp(value);
  const agreeTermsChange = (value) => setAgreeTerms(value);

  const signUp = () => {
    if (agree_to_terms) {
      if (email == '' || username == '' || password == '') {
        checkRequiredFields();
      } else {
        const data = `email=${email}&name=${username}&password=${password}&mobilenumber=${contact}`;
        const config = {
          headers: { 'content-type': 'application/x-www-form-urlencoded' },
        };
        axios
          .post(`${configData.SERVER_URL}/user/register`, data, { config })
          .then((response) => {
            if (response.data.Message == 'Konto er hermed oprettet!') {
              setUserProfile(response.data);
              localStorage.setItem('user_profile', JSON.stringify(response.data));
              mergeGuestWallet(response.data.token);
              setToggleCreateAccountModal(false);
              notificationContext.onPageLoad();
            } else {
              notifyError();
            }
          })
          .catch((error) => {
            emailExisting();
          });
      }
    } else {
      agreeToTermsFirst();
    }
  };

  const agreeToTermsFirst = () => {
    toast(translations[language]?.create_account_agree_terms_error, {
      containerId: 'B',
      icon: <i className="fa fa-exclamation-triangle" />,
    });
  };

  const notifyError = () => {
    toast(translations[language]?.create_account_notify_error, {
      containerId: 'A',
      icon: <i className="fa fa-exclamation-triangle" />,
    });
  };

  const checkRequiredFields = () => {
    toast(translations[language]?.create_account_required_fields_error, {
      icon: <i className="fa fa-exclamation-triangle" />,
    });
  };

  const emailExisting = () => {
    toast(translations[language]?.create_account_email_existing_error, {
      containerId: 'B',
      icon: <i className="fa fa-exclamation-triangle" />,
    });
  };

  const logIn = () => {
    if (!username || !password) {
      setLoginError(
        translations[language]?.login_error_empty_fields || 'Udfyld venligst email og adgangskode',
      );
      return;
    }
    if (!/\S+@\S+\.\S+/.test(username)) {
      setLoginError(
        translations[language]?.login_error_invalid_email || 'Indtast venligst en gyldig email',
      );
      return;
    }

    setLoginError('');
    setLoginLoading(true);
    const data = `email=${username}&password=${password}`;
    const config = {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    };
    axios
      .post(`${configData.SERVER_URL}/user/login`, data, { config })
      .then((response) => {
        setLoginLoading(false);
        if (response.data.Message == 'User successfully logged in') {
          setUserProfile(response.data);
          localStorage.setItem('user_profile', JSON.stringify(response.data));
          mergeGuestWallet(response.data.token);
          localStorage.removeItem('guest-uui');

          orderContext.setIsGuest(false);
          orderContext.setGuestId('');
          closeModal3();
          notificationContext.onPageLoad();
          refetchResto();
        } else {
          setUserProfile([]);
          setLoginError(
            translations[language]?.login_error_wrong_credentials ||
              'Forkert email eller adgangskode',
          );
        }
      })
      .catch((error) => {
        console.error('There was an error!', error);
        setLoginLoading(false);
        setUserProfile([]);
        setLoginError(
          translations[language]?.login_error_wrong_credentials ||
            'Forkert email eller adgangskode',
        );
      });
  };

  const closeModal3 = () => {
    setBasicModal3(false);
  };

  const responseFacebook = (response) => {
    localStorage.setItem('return_url', window.location.href);
    const data = `accesstoken=${response.accessToken}&facebookid=${response.id}`;
    const config = {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    };
    axios
      .post(`${configData.SERVER_URL}/user/auth/facebook/validate`, data, { config })
      .then((response2) => {
        setUserProfile(response2.data);
        localStorage.setItem('user_profile', JSON.stringify(response2.data));
        mergeGuestWallet(response2.data.token);
        notificationContext.onPageLoad();
        refetchResto();
      })
      .catch((error) => {
        console.error('There was an error in calling api!', error);
      });
    closeModal3();
  };

  const googleAuthError = () =>
    translations[language]?.google_signin_error ||
    'Vi kunne ikke logge dig ind med Google. Prøv venligst igen.';

  const googleSingIn = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      const fromSignup = toggleCreateAccountModal;
      setLoginError('');
      setSignupError('');
      localStorage.setItem('return_url', window.location.href);
      const data = `tokenid=${tokenResponse.access_token}`;
      const config = {
        headers: { 'content-type': 'application/x-www-form-urlencoded' },
      };
      axios
        .post(`${configData.SERVER_URL}/user/auth/google/validate/web`, data, { config })
        .then((response2) => {
          setUserProfile(response2.data);
          localStorage.setItem('user_profile', JSON.stringify(response2.data));
          mergeGuestWallet(response2.data.token);
          localStorage.removeItem('guest-uui');

          orderContext.setIsGuest(false);
          orderContext.setGuestId('');
          notificationContext.onPageLoad();
          refetchResto();

          setBasicModal3(false);
          setToggleCreateAccountModal(false);
          if (fromSignup) {
            setSignupSuccess(true);
          }
        })
        .catch((error) => {
          console.error('There was an error in calling api!', error);
          if (fromSignup) {
            setSignupError(googleAuthError());
          } else {
            setLoginError(googleAuthError());
          }
        });
    },
    onError: (error) => {
      console.error('Google sign-in error', error);
      if (toggleCreateAccountModal) {
        setSignupError(googleAuthError());
      } else {
        setLoginError(googleAuthError());
      }
    },
  });

  const handleChangeSignup = (key, value) => {
    setSignupData({ ...signupData, [key]: value });
  };

  const isEmailNotMatch = () => signupData.email1 != signupData.email2;
  const isPasswordNotMatch = () => signupData.password1 != signupData.password2;

  const signUpNew = () => {
    setSignupError('');

    if (!agree_to_terms) {
      setSignupError(
        translations[language]?.create_account_agree_terms_error ||
          'Accepter venligst betingelserne',
      );
      return;
    }

    if (
      !signupData.firstname ||
      !signupData.lastname ||
      !signupData.email1 ||
      !signupData.email2 ||
      !signupData.password1 ||
      !signupData.password2
    ) {
      setSignupError(
        translations[language]?.create_account_required_fields_error ||
          'Udfyld venligst alle felter',
      );
      return;
    }

    if (!isEmailValid(signupData.email1) || !isEmailValid(signupData.email2)) {
      setSignupError(
        translations[language]?.create_account_email_invalid_error ||
          'Indtast venligst en gyldig email',
      );
      return;
    }

    if (signupData.email1 != signupData.email2) {
      setSignupError(
        translations[language]?.create_account_email_error ||
          'Email adresserne stemmer ikke overens',
      );
      return;
    }

    if (signupData.password1 != signupData.password2) {
      setSignupError(
        translations[language]?.create_account_password_error ||
          'Adgangskoderne stemmer ikke overens',
      );
      return;
    }

    setSignupLoading(true);
    const data = {
      email: signupData.email2,
      name: signupData.firstname + ' ' + signupData.lastname,
      password: signupData.password2,
      mobilenumber: signupData.mobilenumber,
    };
    const config = {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    };
    axios
      .post(`${configData.SERVER_URL}/user/register`, data, { config })
      .then((response) => {
        setSignupLoading(false);
        if (response.data.Message == 'User successfully registered.') {
          setToggleCreateAccountModal(false);
          setSignupSuccess(true);
          notificationContext.onPageLoad();
          logInUponSignup(signupData.email2, signupData.password2);
          return;
        } else {
          setSignupError(
            translations[language]?.create_account_notify_error || 'Noget gik galt. Prøv igen.',
          );
        }
      })
      .catch((error) => {
        setSignupLoading(false);
        setSignupError(
          translations[language]?.create_account_email_existing_error ||
            'Denne email er allerede registreret',
        );
      });
  };

  const isEmailValid = (email) => {
    var re = /\S+@\S+\.\S+/;
    return re?.test(email);
  };

  const refetchResto = async () => {
    await restaurantContext.loadRestaurants();
  };

  const logInUponSignup = (email, password) => {
    const data = `email=${email}&password=${password}`;
    const config = {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    };
    axios
      .post(`${configData.SERVER_URL}/user/login`, data, { config })
      .then((response) => {
        if (response.data.Message == 'User successfully logged in') {
          setUserProfile(response.data);
          localStorage.setItem('user_profile', JSON.stringify(response.data));
          mergeGuestWallet(response.data.token);
          notificationContext.onPageLoad();
          refetchResto();

          localStorage.removeItem('guest-uui');

          orderContext.setIsGuest(false);
          orderContext.setGuestId('');
        } else {
          setUserProfile([]);
          notifyError();
        }
      })
      .catch((error) => {
        console.error('There was an error!', error);
        setUserProfile([]);
        notifyError();
      });
  };

  const submitReset = (e) => {
    e.preventDefault();

    const data = { email: forgotPasswordEmail };
    const config = {
      headers: { 'content-type': 'application/x-www-form-urlencoded' },
    };
    axios
      .post(`${configData.SERVER_URL}/user/forgotpassword`, data, { config })
      .then((response) => {
        toast(translations[language]?.create_account_email_check_toast, {
          containerId: 'A',
          autoClose: false,
        });
        setForgotPassword(false);
        setForgotPasswordEmail('');
      })
      .catch((error) => {
        toast(translations[language]?.create_account_email_not_found_error, {
          containerId: 'B',
          icon: <i className="fa fa-exclamation-triangle" />,
        });
      });
  };

  const logInAsGuest = () => {
    // A STRING, like every other guest id: localStorage stringifies this anyway,
    // so a number only ever lived in context until the next reload — and posted
    // as JSON it passes the backend's ObjectId.isValid() guard (numbers do) and
    // then throws a CastError in Users.findById, 503-ing /discountcode/validate.
    const uuid = String(new Date().getTime()) || '';
    orderContext.setIsGuest(true);
    orderContext.setGuestId(uuid);
    localStorage.setItem('guest-uui', uuid);
    if (orderContext.shouldShowReview) {
      orderContext.setReviewModal(true);
    }
  };

  const handleAuthAction = () => {
    if (isLoggedIn) {
      logOut();
    } else {
      toggleShow2();
    }
  };

  const handleAccountAction = () => {
    if (isLoggedIn) {
      navigate('/profile');
    } else {
      setToggleCreateAccountModal(!toggleCreateAccountModal);
    }
  };

  const isLoggedIn =
    (localStorage.getItem('user_profile') !== undefined &&
      localStorage.getItem('user_profile') !== null) ||
    (!isEmpty(userProfile) && userProfile.length !== 0 && userProfile !== null);

  // HeyWaitr+ member (from the cached profile flag) → shows a gold member badge.
  const isPremium = !!userProfile?.profile?.isSubscribed;

  const isGuest =
    localStorage.getItem('guest-uui') !== undefined && localStorage.getItem('guest-uui') !== null;

  // Wallet link is shown for logged-in users AND guests-with-a-wallet-token (§9.4).
  const hasWalletToken =
    localStorage.getItem('hw-wallet-token') !== undefined &&
    localStorage.getItem('hw-wallet-token') !== null;
  const showWallet = isLoggedIn || hasWalletToken;

  const [showQrModal, setShowQrModal] = useState(false);
  const [qrTab, setQrTab] = useState('scan');
  const [qrTable, setQrTable] = useState('');
  const [qrTableNumbers, setQrTableNumbers] = useState([]);
  const [qrTableNumbersLoading, setQrTableNumbersLoading] = useState(false);

  const handleQrOpen = () => {
    setShowQrModal(true);
    setQrTab('scan');
  };

  const handleQrClose = () => {
    setShowQrModal(false);
    setQrTable('');
    setQrTableNumbers([]);
  };

  const handleQrScan = (text) => {
    handleQrClose();
    try {
      const url = new URL(text);
      if (url.pathname.startsWith('/restaurant-together/')) {
        navigate(url.pathname);
      }
    } catch {}
  };

  const handleQrTabChange = async (tab) => {
    setQrTab(tab);
    if (tab === 'generate' && qrTableNumbers.length === 0 && restaurant && restaurantId) {
      setQrTableNumbersLoading(true);
      try {
        const resp = await axios.get(
          `${configData.SERVER_URL}/tableno/mobile/fetch?restaurant=${restaurantId}`,
        );
        const tables = (resp.data || []).map((t) => ({
          label: t.label || t.number,
          value: t.number,
          qrLink:
            t.qrLink ||
            `${window.location.origin}/restaurant-together/${restaurantId}/${encodeURIComponent(t.number)}`,
        }));

        setQrTableNumbers(tables);
        if (tables.length > 0) setQrTable(tables[0].value);
      } catch {
        setQrTableNumbers([]);
      } finally {
        setQrTableNumbersLoading(false);
      }
    }
  };

  return (
    <>
      {/* ── NAVBAR ── */}
      <nav
        className="fixed w-full z-[100] top-0 left-0 py-2 flex items-center bg-white shadow-md"
        style={{
          boxShadow: '0 4px 10px 0 rgba(0, 0, 0, 0.05)',
          '--primary': restaurant?.PrimaryColor || '#96c11f',
          '--secondary': restaurant?.SecondaryColor || '#6f9800',
          '--text': restaurant?.TextColor || '#ffffff',
        }}
      >
        <div className="header_container flex justify-between items-center w-full px-4">
          <div className="mr-0 sm:mr-2 custom_navbar_item">
            <Link to="/">
              <img
                src="/heywaitr.b08c1632.jpg"
                className="h-[25px] sm:h-[30px] md:h-[35px]"
                alt="heywaitr"
                loading="lazy"
              />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="items-center hidden lg:flex gap-1">
            <button
              className="text-sm text-gray-600 font-medium hover:text-gray-900 py-1.5 px-1 lg:px-2 rounded-md bg-transparent hover:bg-gray-100 transition-colors duration-200"
              onClick={() => navigate('/')}
            >
              {translations[language]?.home_page}
            </button>

            <button
              className="text-sm text-gray-600 font-medium hover:text-gray-900 py-1.5 px-1 lg:px-2 rounded-md bg-transparent hover:bg-gray-100 transition-colors duration-200"
              onClick={() => navigate('/')}
            >
              {translations[language]?.restaurants}
            </button>

            {isLoggedIn && (
              <button
                className="text-sm text-gray-600 font-medium hover:text-gray-900 py-1.5 px-1 lg:px-2 rounded-md bg-transparent hover:bg-gray-100 transition-colors duration-200"
                onClick={() => navigate('/orders')}
              >
                {translations[language]?.orders}
              </button>
            )}

            {showWallet && (
              <button
                className="text-sm text-gray-600 font-medium hover:text-gray-900 py-1.5 px-1 lg:px-2 rounded-md bg-transparent hover:bg-gray-100 transition-colors duration-200"
                onClick={() => navigate('/wallet')}
              >
                {translations[language]?.wallet || 'Wallet'}
              </button>
            )}

            {/* HeyWaitr+ menu — subscribers get a dropdown of sub-pages;
                non-subscribers get a plain link. */}
            {isPremium ? (
              <div className="relative group">
                <button
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-gray-700 hover:text-gray-900 py-1.5 px-1 lg:px-2 rounded-md bg-transparent hover:bg-gray-100 group-focus-within:bg-gray-100 transition-colors duration-200"
                  onClick={(e) => {
                    e.currentTarget.blur();
                    navigate('/heywaitr-plus');
                  }}
                  aria-haspopup="menu"
                >
                  <span>
                    heywaitr<span className="text-[#e5ca17]">+</span>
                  </span>
                  <i className="fa fa-chevron-down text-[9px] text-gray-400 transition-transform duration-200 group-hover:rotate-180 group-focus-within:rotate-180" />
                </button>

                {/* Dropdown */}
                <div className="absolute left-0 top-full pt-2 min-w-[100px] invisible opacity-0 translate-y-1 group-hover:visible group-hover:opacity-100 group-hover:translate-y-0 group-focus-within:visible group-focus-within:opacity-100 group-focus-within:translate-y-0 transition-all duration-150 z-[110]">
                  <div className="bg-white rounded-xl shadow-lg border border-gray-100 py-1.5">
                    <button
                      role="menuitem"
                      className="flex items-center gap-2.5 w-full px-3.5 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors text-left"
                      onClick={(e) => {
                        e.currentTarget.blur();
                        navigate('/heywaitr-plus');
                      }}
                    >
                      <i className="fa fa-tags w-4 text-center text-[#e5ca17]" />
                      {translations[language]?.deals_nav || 'Deals'}
                    </button>
                    <button
                      role="menuitem"
                      className="flex items-center gap-2.5 w-full px-3.5 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors text-left"
                      onClick={(e) => {
                        e.currentTarget.blur();
                        navigate('/perks');
                      }}
                    >
                      <i className="fa fa-gift w-4 text-center text-[#e5ca17]" />
                      {translations[language]?.perks_nav || 'Perks'}
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <button
                className="text-sm font-semibold text-gray-700 hover:text-gray-900 py-1.5 px-1 lg:px-2 rounded-md bg-transparent hover:bg-gray-100 group-focus-within:bg-gray-100 transition-colors duration-200"
                onClick={() => navigate('/heywaitr-plus')}
              >
                heywaitr<span className="text-[#e5ca17]">+</span>
              </button>
            )}

            <button
              className="px-2 rounded-md text-gray-500 hover:text-primary hover:bg-gray-100 transition-colors duration-200"
              onClick={handleQrOpen}
              title={translations[language]?.dine_together_scan_qr || 'Scan QR'}
            >
              <i className="fa fa-qrcode text-lg" />
            </button>

            <div className="w-px h-5 bg-gray-200 mx-2" />

            {isPremium && (
              <button
                className="inline-flex items-center gap-1.5 bg-[#e5ca17]/15 hover:bg-[#e5ca17]/35 text-[#8a7400] transition-colors border border-[#e5ca17]/40 rounded-full px-2.5 py-1 text-[11px] font-bold"
                onClick={() => navigate('/profile#subscription')}
              >
                <i className="fa fa-crown text-[#e5ca17]" />
                <span className="hidden xl:inline">heywaitr+</span>
              </button>
            )}

            <button
              className="text-sm text-gray-500 font-normal hover:text-primary py-1.5 px-1 lg:px-2 bg-transparent border-none cursor-pointer transition-colors duration-200"
              onClick={handleAccountAction}
            >
              {isLoggedIn
                ? `${translations[language]?.my_profile}`
                : `${translations[language]?.create_account}`}
            </button>

            <button
              className="text-sm text-gray-800 font-medium hover:text-primary py-1.5 px-1 lg:px-2 bg-transparent border-none cursor-pointer transition-colors duration-200"
              onClick={handleAuthAction}
            >
              {isLoggedIn ? translations[language]?.log_out : translations[language]?.log_in}
            </button>

            <div className="ml-1">
              <LanguageSelectorDropdown />
            </div>
          </div>

          {/* Mobile Navigation */}
          <MobileNavbar
            isLoggedIn={isLoggedIn}
            showWallet={showWallet}
            isPremium={isPremium}
            onAuthAction={handleAuthAction}
            onAccountAction={handleAccountAction}
            onQrAction={handleQrOpen}
          />
        </div>
      </nav>

      {/* ── LOGIN MODAL ── */}
      <Modal
        isOpen={basicModal3}
        onClose={() => setBasicModal3(false)}
        contentClassName="max-w-[470px]"
      >
        <div className="pt-8 px-6 pb-6">
          {/* Header */}
          <div className="text-center mb-7">
            <h2 className="text-2xl font-bold text-[#1a1a1a] mb-1.5">
              {translations[language]?.login_modal_title}
            </h2>
            <p className="text-sm text-gray-400">{translations[language]?.login_modal_subtitle}</p>
          </div>

          <div className="flex flex-col gap-3">
            {/* Guest order - primary action */}
            <button
              className="w-full py-[14px] text-[15px] font-semibold bg-[#96c11f] hover:bg-[#7ba819] text-white border-none rounded-xl cursor-pointer transition-colors duration-200 flex items-center justify-center gap-2"
              onClick={() => {
                logInAsGuest();
                setBasicModal3(false);
              }}
            >
              {translations[language]?.login_modal_order_as_guest_button}
            </button>

            {/* Google login */}
            <button
              onClick={() => googleSingIn()}
              className="sign_in_others googlebtn w-full py-[14px] text-sm font-medium bg-white text-[#333] border border-[#e0e0e0] hover:border-[#bbb] rounded-xl cursor-pointer transition-[border-color] duration-200 flex items-center justify-center gap-2.5"
            >
              <img src="https://www.google.com/favicon.ico" alt="G" className="w-[18px] h-[18px]" />
              {translations[language]?.login_modal_google_button}
            </button>

            {/* Divider */}
            <div className="flex items-center gap-3 my-1">
              <div className="flex-1 h-px bg-[#e5e5e5]" />
              <span className="text-[11px] text-[#aaa] uppercase font-semibold tracking-[1px]">
                {translations[language]?.login_modal_or_email || 'eller e-mail'}
              </span>
              <div className="flex-1 h-px bg-[#e5e5e5]" />
            </div>

            {/* Email & Password */}
            <form
              onSubmit={(e) => {
                e.preventDefault();
                logIn();
              }}
              className="contents"
            >
              <div>
                <label className={labelCls}>
                  {translations[language]?.login_modal_email_label || 'E-mail adresse'}
                </label>
                <input
                  ref={loginEmailRef}
                  id="username"
                  type="email"
                  autoComplete="email"
                  placeholder={translations[language]?.login_modal_email_placeholder}
                  onChange={(e) => {
                    usernameChange(e.target.value);
                    setLoginError('');
                  }}
                  onFocus={() => setLoginError('')}
                  tabIndex={1}
                  className={loginError ? inputErrorCls : inputCls}
                />
              </div>

              <div>
                <label className={labelCls}>
                  {translations[language]?.login_modal_password_label || 'Adgangskode'}
                </label>
                <div className="relative">
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    autoComplete="current-password"
                    placeholder={translations[language]?.login_modal_password_placeholder}
                    onChange={(e) => {
                      passwordChange(e.target.value);
                      setLoginError('');
                    }}
                    onFocus={() => setLoginError('')}
                    tabIndex={2}
                    className={`${loginError ? inputErrorCls : inputCls} pr-11`}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 bg-transparent border-none cursor-pointer text-base text-gray-400 p-1"
                    tabIndex={-1}
                  >
                    {showPassword ? (
                      <img
                        src="/eye-closed.png"
                        className="h-[8px]"
                        alt="eye closed"
                        style={{
                          filter:
                            'invert(75%) sepia(0%) saturate(0%) hue-rotate(30deg) brightness(90%) contrast(90%)',
                        }}
                      />
                    ) : (
                      <i className="fa fa-eye" />
                    )}
                  </button>
                </div>
                <div className="text-right mt-1.5">
                  <button
                    type="button"
                    className="text-[13px] text-primary font-medium bg-transparent border-none cursor-pointer hover:underline"
                    onClick={() => {
                      setBasicModal3(false);
                      setForgotPassword(true);
                    }}
                  >
                    {translations[language]?.login_modal_forgot_password_button}?
                  </button>
                </div>
              </div>

              {/* Error message */}
              {loginError && (
                <div className="px-3.5 py-2.5 bg-red-50 border border-red-200 rounded-xl text-[13px] text-red-600 flex items-center gap-2">
                  <i className="fa fa-exclamation" /> {loginError}
                </div>
              )}

              {/* Log in button */}
              <button
                type="submit"
                disabled={loginLoading}
                className={`w-full py-[14px] text-[15px] font-semibold text-white border-none rounded-xl transition-colors duration-200 flex items-center justify-center gap-2 ${
                  loginLoading
                    ? 'bg-gray-500 cursor-wait'
                    : !username || !password
                      ? 'bg-gray-300 cursor-default'
                      : 'bg-[#1a1a1a] hover:bg-[#333] cursor-pointer'
                }`}
                onClick={() => logIn()}
              >
                {loginLoading && (
                  <span className="w-[18px] h-[18px] rounded-full border-2 border-white/30 border-t-white animate-spin inline-block" />
                )}
                {loginLoading
                  ? translations[language]?.login_loading || 'Logger ind...'
                  : translations[language]?.log_in}
              </button>
            </form>

            {/* Create account */}
            <button
              className="w-full py-[14px] text-sm font-medium bg-white text-[#333] border border-[#e0e0e0] hover:border-[#96c11f] rounded-xl cursor-pointer transition-[border-color] duration-200"
              onClick={() => {
                setToggleCreateAccountModal(!toggleCreateAccountModal);
                setBasicModal3(false);
              }}
            >
              {translations[language]?.login_modal_create_via_email_button}
            </button>

            {/* Description */}
            <p className="text-xs text-gray-400 text-center leading-relaxed mt-1">
              {translations[language]?.login_modal_description}
            </p>
          </div>
        </div>
      </Modal>

      {/* ── CREATE ACCOUNT MODAL ── */}
      <Modal
        isOpen={toggleCreateAccountModal}
        onClose={() => {
          setToggleCreateAccountModal(false);
          setSignupError('');
          setShowSignupPassword(false);
        }}
        contentClassName="max-w-[470px]"
      >
        <div>
          {/* Header */}
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-[#1a1a1a] mb-1.5">
              {translations[language]?.create_account_title}
            </h2>
            <p className="text-sm text-gray-400">
              {translations[language]?.create_account_description}
            </p>
            <p className="text-sm text-gray-400 mt-1">
              {translations[language]?.create_account_already_have}{' '}
              <button
                className="text-primary font-semibold bg-transparent border-none cursor-pointer"
                onClick={() => {
                  setToggleCreateAccountModal(false);
                  setTimeout(() => toggleShow2(), 400);
                }}
              >
                {translations[language]?.log_in}
              </button>
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {/* Google signup */}
            <button
              onClick={() => googleSingIn()}
              className="sign_in_others googlebtn w-full py-[14px] text-sm font-medium bg-white text-[#333] border border-[#e0e0e0] hover:border-[#bbb] rounded-xl cursor-pointer transition-[border-color] duration-200 flex items-center justify-center gap-2.5"
            >
              <img src="https://www.google.com/favicon.ico" alt="G" className="w-[18px] h-[18px]" />
              {translations[language]?.signup_with_google || 'Opret konto med Google'}
            </button>

            {/* Divider: Eller med email */}
            <div className="flex items-center gap-3">
              <div className="flex-1 h-px bg-[#e5e5e5]" />
              <span className="text-[11px] text-[#aaa] uppercase font-semibold tracking-[1px]">
                {translations[language]?.login_modal_or_email || 'eller e-mail'}
              </span>
              <div className="flex-1 h-px bg-[#e5e5e5]" />
            </div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                signUpNew();
              }}
              className="contents"
            >
              {/* Divider: Navn */}
              <div className="flex items-center gap-3">
                <div className="flex-1 h-px bg-[#e5e5e5]" />
                <span className="text-[11px] text-[#aaa] uppercase font-semibold tracking-[1px]">
                  {translations[language]?.label_name || 'Navn'}
                </span>
                <div className="flex-1 h-px bg-[#e5e5e5]" />
              </div>

              <div>
                <label className={labelCls}>
                  {translations[language]?.label_first_name || 'Fornavn'}
                </label>
                <input
                  ref={signupFirstNameRef}
                  type="text"
                  autoComplete="given-name"
                  placeholder={translations[language]?.create_account_first_name}
                  value={signupData['firstname'] || ''}
                  onChange={(e) => {
                    handleChangeSignup('firstname', e.target.value);
                    setSignupError('');
                  }}
                  tabIndex={1}
                  className={inputCls}
                />
              </div>

              <div>
                <label className={labelCls}>
                  {translations[language]?.label_last_name || 'Efternavn'}
                </label>
                <input
                  type="text"
                  autoComplete="family-name"
                  placeholder={translations[language]?.create_account_last_name}
                  value={signupData['lastname'] || ''}
                  onChange={(e) => {
                    handleChangeSignup('lastname', e.target.value);
                    setSignupError('');
                  }}
                  tabIndex={2}
                  className={inputCls}
                />
              </div>

              {/* Divider: Contact info */}
              <div className="flex items-center gap-3 mt-1">
                <div className="flex-1 h-px bg-[#e5e5e5]" />
                <span className="text-[11px] text-[#aaa] uppercase font-semibold tracking-[1px]">
                  {translations[language]?.label_contact_info || 'Kontaktoplysninger'}
                </span>
                <div className="flex-1 h-px bg-[#e5e5e5]" />
              </div>

              <div>
                <label className={labelCls}>{translations[language]?.label_email || 'Email'}</label>
                <input
                  type="email"
                  autoComplete="email"
                  placeholder={translations[language]?.create_account_email}
                  value={signupData['email1'] || ''}
                  onChange={(e) => {
                    handleChangeSignup('email1', e.target.value);
                    setSignupError('');
                  }}
                  tabIndex={3}
                  className={inputCls}
                />
              </div>

              <div>
                <label className={labelCls}>
                  {translations[language]?.label_confirm_email || 'Gentag email'}
                </label>
                <input
                  type="email"
                  placeholder={translations[language]?.create_account_email_confirm}
                  value={signupData['email2'] || ''}
                  onChange={(e) => {
                    handleChangeSignup('email2', e.target.value);
                    setSignupError('');
                  }}
                  tabIndex={4}
                  className={
                    signupData['email1'] && signupData['email2'] && isEmailNotMatch()
                      ? inputErrorCls
                      : inputCls
                  }
                />
              </div>

              {signupData['email1'] && signupData['email2'] && isEmailNotMatch() && (
                <div className="px-2 py-2 bg-red-50 border border-red-200 rounded-lg text-xs text-red-600 flex items-center gap-1.5">
                  <span>⚠️</span> {translations[language]?.create_account_email_error}
                </div>
              )}

              <div>
                <label className={labelCls}>
                  {translations[language]?.label_phone || 'Telefonnummer'}
                </label>
                <input
                  type="tel"
                  autoComplete="tel"
                  placeholder={translations[language]?.create_account_mobile_number}
                  value={signupData['mobilenumber'] || ''}
                  onChange={(e) => {
                    handleChangeSignup('mobilenumber', e.target.value);
                    setSignupError('');
                  }}
                  tabIndex={5}
                  className={inputCls}
                />
              </div>

              {/* Divider: Password */}
              <div className="flex items-center gap-3 mt-1">
                <div className="flex-1 h-px bg-[#e5e5e5]" />
                <span className="text-[11px] text-[#aaa] uppercase font-semibold tracking-[1px]">
                  {translations[language]?.password}
                </span>
                <div className="flex-1 h-px bg-[#e5e5e5]" />
              </div>

              <div>
                <label className={labelCls}>
                  {translations[language]?.label_password || 'Kodeord'}
                </label>
                <div className="relative">
                  <input
                    type={showSignupPassword ? 'text' : 'password'}
                    autoComplete="new-password"
                    placeholder={translations[language]?.create_account_password}
                    value={signupData['password1'] || ''}
                    onChange={(e) => {
                      handleChangeSignup('password1', e.target.value);
                      setSignupError('');
                    }}
                    tabIndex={6}
                    className={`${inputCls} pr-11`}
                  />
                  <button
                    type="button"
                    onClick={() => setShowSignupPassword(!showSignupPassword)}
                    className="absolute right-3 top-1/2 -translate-y-1/2 bg-transparent border-none cursor-pointer text-base text-gray-400 p-1"
                    tabIndex={-1}
                  >
                    {showSignupPassword ? (
                      <img
                        src="/eye-closed.png"
                        className="h-[8px]"
                        alt="eye closed"
                        style={{
                          filter:
                            'invert(75%) sepia(0%) saturate(0%) hue-rotate(30deg) brightness(90%) contrast(90%)',
                        }}
                      />
                    ) : (
                      <i className="fa fa-eye" />
                    )}
                  </button>
                </div>
              </div>

              <div>
                <label className={labelCls}>
                  {translations[language]?.label_confirm_password || 'Gentag kodeord'}
                </label>
                <div className="relative">
                  <input
                    type={showSignupPassword ? 'text' : 'password'}
                    autoComplete="new-password"
                    placeholder={translations[language]?.create_account_password_confirm}
                    value={signupData['password2'] || ''}
                    onChange={(e) => {
                      handleChangeSignup('password2', e.target.value);
                      setSignupError('');
                    }}
                    tabIndex={7}
                    className={
                      signupData['password1'] && signupData['password2'] && isPasswordNotMatch()
                        ? `${inputErrorCls} pr-11`
                        : `${inputCls} pr-11`
                    }
                  />
                </div>
              </div>

              {signupData['password1'] && signupData['password2'] && isPasswordNotMatch() && (
                <div className="px-2 py-2 bg-red-50 border border-red-200 rounded-lg text-xs text-red-600 flex items-center gap-1.5">
                  <span>⚠️</span> {translations[language]?.create_account_password_error}
                </div>
              )}

              {/* Terms */}
              <div className="flex items-start gap-2.5 mt-1">
                <input
                  id="agree_to_terms"
                  type="checkbox"
                  onChange={(e) => agreeTermsChange(e.target.checked)}
                  className="w-5 h-5 mt-0.5 cursor-pointer"
                  style={{ accentColor: '#96c11f' }}
                />
                <label
                  htmlFor="agree_to_terms"
                  className="text-[13px] text-gray-500 leading-relaxed cursor-pointer"
                >
                  {translations[language]?.create_account_conditions_description}{' '}
                  <a
                    href="https://www.heywaitr.com/heywaitr-app-global-terms-and-conditions/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-primary font-semibold hover:underline"
                  >
                    {translations[language]?.create_account_conditions}
                  </a>
                </label>
              </div>

              {/* Error message */}
              {signupError && (
                <div className="px-3.5 py-2.5 bg-red-50 border border-red-200 rounded-xl text-[13px] text-red-600 flex items-center gap-2">
                  <span>⚠️</span> {signupError}
                </div>
              )}

              {/* Submit */}
              <button
                type="submit"
                disabled={signupLoading}
                className={`w-full py-[14px] text-[15px] font-semibold text-white border-none rounded-xl transition-colors duration-200 mt-1 flex items-center justify-center gap-2 ${
                  signupLoading
                    ? 'bg-[#b5d96e] cursor-wait'
                    : 'bg-[#96c11f] hover:bg-[#7ba819] cursor-pointer'
                }`}
              >
                {signupLoading && (
                  <span className="w-[18px] h-[18px] rounded-full border-2 border-white/30 border-t-white animate-spin inline-block" />
                )}
                {signupLoading
                  ? translations[language]?.signup_loading || 'Opretter konto...'
                  : translations[language]?.create_account}
              </button>
            </form>
          </div>
        </div>
      </Modal>

      {/* ── SIGNUP SUCCESS MODAL ── */}
      <Modal
        isOpen={signupSuccess}
        onClose={() => setSignupSuccess(false)}
        noCloseButton={true}
        contentClassName="max-w-[470px]"
      >
        <div className="text-center pt-10 px-6 pb-8 space-y-4">
          <div
            className="w-[72px] h-[72px] rounded-full flex items-center justify-center mx-auto shadow-[0_4px_16px_rgba(150,193,31,0.3)]"
            style={{ background: 'linear-gradient(135deg, #96c11f 0%, #7ba819 100%)' }}
          >
            <span className="text-3xl">🎉</span>
          </div>
          <h3 className="text-xl font-bold text-[#1a1a1a]">
            {translations[language]?.create_account_account_create_success_toast ||
              'Din konto er oprettet. Du er nu logget ind og klar til at bestille.'}
          </h3>
          <button
            className="w-full py-[14px] px-6 text-[15px] font-semibold bg-[#96c11f] hover:bg-[#7ba819] text-white border-none rounded-xl cursor-pointer transition-colors duration-200 shadow-[0_2px_8px_rgba(150,193,31,0.3)]"
            onClick={() => setSignupSuccess(false)}
          >
            {translations[language]?.signup_success_button || 'Kom i gang'}
          </button>
        </div>
      </Modal>

      {/* ── RESET PASSWORD MODAL ── */}
      <Modal
        isOpen={forgotPassword}
        onClose={() => setForgotPassword(false)}
        contentClassName="max-w-[470px]"
      >
        <div className="pt-8 px-6 pb-6">
          <div className="text-center mb-6">
            <div
              className="w-[72px] h-[72px] rounded-full flex items-center justify-center mx-auto mb-5 shadow-[0_4px_16px_rgba(111,152,0,0.3)]"
              style={{ background: 'linear-gradient(135deg, #96c11f 0%, #6f9800 100%)' }}
            >
              <span className="text-3xl">🔑</span>
            </div>
            <h3 className="text-[22px] font-bold text-[#1a1a1a] mb-1.5">
              {translations[language]?.reset_password}
            </h3>
            <p className="text-sm text-gray-400">
              {translations[language]?.reset_password_description ||
                'Indtast din email så sender vi dig et link til at nulstille din adgangskode.'}
            </p>
          </div>

          <form onSubmit={submitReset} className="flex flex-col gap-3">
            <div>
              <label className={labelCls}>
                {translations[language]?.login_modal_email_label || 'E-mail adresse'}
              </label>
              <input
                type="email"
                autoComplete="email"
                placeholder={translations[language]?.login_modal_email_placeholder}
                onChange={(e) => setForgotPasswordEmail(e.target.value)}
                value={forgotPasswordEmail}
                required
                className="w-full py-3 px-4 text-sm bg-[#f5f5f5] border border-transparent rounded-[10px] outline-none text-[#333] transition-[border-color] duration-200 focus:border-blue-500"
              />
            </div>

            <button
              type="submit"
              className="w-full py-[14px] text-[15px] font-semibold bg-primary hover:bg-secondary text-white border-none rounded-xl cursor-pointer transition-colors duration-200"
            >
              {translations[language]?.reset}
            </button>

            <button
              type="button"
              className="w-full py-3 text-[13px] font-medium bg-transparent text-gray-400 border-none cursor-pointer"
              onClick={() => {
                setForgotPassword(false);
                setBasicModal3(true);
              }}
            >
              ← {translations[language]?.back_to_login || 'Tilbage til log ind'}
            </button>
          </form>
        </div>
      </Modal>

      {/* ── QR MODAL ── */}
      {showQrModal && (
        <div
          style={{
            '--primary': restaurant?.PrimaryColor || '#96c11f',
            '--secondary': restaurant?.SecondaryColor || '#6f9800',
            '--text': restaurant?.TextColor || '#ffffff',
          }}
          className="fixed inset-0 z-[200] flex items-end sm:items-center justify-center"
        >
          <div className="fixed inset-0 bg-black/60" onClick={handleQrClose} />
          <div className="relative bg-white w-full max-w-sm rounded-t-3xl sm:rounded-2xl shadow-2xl z-10 overflow-hidden">
            {/* Header */}
            <div className="flex items-center justify-between px-5 pt-5 pb-3">
              <h3 className="font-bold text-gray-900 text-base">
                {translations[language]?.dine_together_scan_qr || 'Scan QR'}
              </h3>
              <button
                className="p-1.5 rounded-full text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                onClick={handleQrClose}
              >
                <i className="fa fa-times text-sm" />
              </button>
            </div>

            {/* Content */}
            <div className="px-5 pb-6">
              <QrScanView
                onScan={handleQrScan}
                hint={
                  translations[language]?.dine_together_scan_hint ||
                  'Point your camera at the table QR code'
                }
                errorText={translations[language]?.dine_together_camera_error}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
